import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';

// Components
import * as icons from '../Icons/Icons';

const Downloads = observer(class Downloads extends React.Component {
  componentWillMount() {
    this.props.store.ReportStore.getDownloads();
  }

  statusClass(download) {
    let className = '';

    if(download.status) {
      switch (download.status.toLowerCase()) {
        case 'complete':
          className = 'success';
          break;

        default:
          className = 'pending';
          break;
      }
    }

    return className;
  }

  statusIcon(download) {
    if(download.status) {
      if(download.status.toLowerCase() === 'complete') {
        return (
          <icons.iconCheckCircle />
        )
      } else if(download.status.toLowerCase() === 'exporting') {
        return (
          <icons.iconHourglass />
        )
      }
    }

    return null;
  }

  renderResults() {
    const { translation } = this.props;
    const { ReportStore, SessionStore } = this.props.store;
    const { downloads } = ReportStore;

    if(!SessionStore.loading) {
      if(downloads.length > 0) {
        return (
          <table>
            <thead>
              <tr>
                <th scope="col" id="heading-title" className="subtitle">{translation.title}</th>
                <th scope="col" id="heading-date" className="subtitle">{translation.date}</th>
                <th scope="col" id="heading-status" className="subtitle">{translation.status}</th>
                <th scope="col" id="heading-download" className="subtitle">{translation.download}</th>
              </tr>
            </thead>
            <tbody>
              {downloads.map(
                (download) =>
                <tr key={download.sid}>
                  <td aria-labelledby="heading-title">
                    {download.title}
                  </td>
                  <td aria-labelledby="heading-date">
                    {moment.utc(download.createdDate).tz(moment.tz.guess()).format('M/D/YYYY h:mma z')}
                  </td>
                  <td aria-labelledby="heading-status" className={`capitalize ${this.statusClass(download)}`}>
                    {this.statusIcon(download)}
                    {download.status}

                    {download.status && download.status.toLowerCase() === 'exporting' &&
                      <span className="pill pill--alt pill--right">
                        {download.completionPercentage}%
                      </span>
                    }
                  </td>
                  <td aria-labelledby="heading-download" className="actions">
                    {download.status === 'complete' &&
                      <a
                        className="btn--outline"
                        href={`https://s3.amazonaws.com/${download.s3Bucket}/${download.s3FilePath}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <icons.iconDownload />
                        {translation.download}
                      </a>
                    }
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )
      } else {
        return (
          <span className="no-results">{translation.no_results}</span>
        )
      }
    }

    return null;
  }

  render() {
    const { translation } = this.props;

    return (
      <main tabIndex="0" id="main-content" className="page">
        <header className="page__header">
          <div className="wrap">
            <h1 className="page__title">
              {translation.page_title}

              <Link className="page__back" to="/reports">
                Back to all reports
              </Link>
            </h1>
          </div>
        </header>

        <div className="wrap">
          {this.renderResults()}
        </div>
      </main>
    )
  }
})

export default translate('Downloads')(Downloads);



// WEBPACK FOOTER //
// ./src/app/components/Reports/Downloads.js